/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentsControllerFindAllStepsQueryResponse, DocumentsControllerFindAllStepsPathParams, DocumentsControllerFindAllSteps401, DocumentsControllerFindAllSteps403 } from "../../models/documentsController/DocumentsControllerFindAllSteps";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { documentsControllerFindAllSteps } from "../../clients/documentsService/documentsControllerFindAllSteps";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const documentsControllerFindAllStepsQueryKey = (id: DocumentsControllerFindAllStepsPathParams["id"], processingId: DocumentsControllerFindAllStepsPathParams["processingId"]) => [{
  url: '/api/v1/documents/:id/processing/:processingId/steps',
  params: {
    id: id,
    processingId: processingId
  }
}] as const;
export type DocumentsControllerFindAllStepsQueryKey = ReturnType<typeof documentsControllerFindAllStepsQueryKey>;
export function documentsControllerFindAllStepsQueryOptions(id: DocumentsControllerFindAllStepsPathParams["id"], processingId: DocumentsControllerFindAllStepsPathParams["processingId"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = documentsControllerFindAllStepsQueryKey(id, processingId);
  return queryOptions<DocumentsControllerFindAllStepsQueryResponse, ResponseErrorConfig<DocumentsControllerFindAllSteps401 | DocumentsControllerFindAllSteps403>, DocumentsControllerFindAllStepsQueryResponse, typeof queryKey>({
    enabled: !!(id && processingId),
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return documentsControllerFindAllSteps(id, processingId, config);
    }
  });
}

/**
 * @summary Get all steps for a processing job
 * {@link /api/v1/documents/:id/processing/:processingId/steps}
 */
export function useDocumentsControllerFindAllSteps<TData = DocumentsControllerFindAllStepsQueryResponse, TQueryData = DocumentsControllerFindAllStepsQueryResponse, TQueryKey extends QueryKey = DocumentsControllerFindAllStepsQueryKey>(id: DocumentsControllerFindAllStepsPathParams["id"], processingId: DocumentsControllerFindAllStepsPathParams["processingId"], options: {
  query?: Partial<QueryObserverOptions<DocumentsControllerFindAllStepsQueryResponse, ResponseErrorConfig<DocumentsControllerFindAllSteps401 | DocumentsControllerFindAllSteps403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? documentsControllerFindAllStepsQueryKey(id, processingId);
  const query = useQuery({
    ...documentsControllerFindAllStepsQueryOptions(id, processingId, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<DocumentsControllerFindAllSteps401 | DocumentsControllerFindAllSteps403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}